import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {Checkbox} from "primereact/checkbox";
import {ColorPicker} from "primereact/colorpicker";

const EventtypeFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const payload = {
      name: formData.name || '',
      color: formData.color || '#ff0000',
      is_employee: !!formData.is_employee,
    }
    if ((window.App.urlVars().eventtypeId) || (entity === 'event-type' && id)) {
      apiCall('patch', '/api/v2/recruitment-event-type/' + (window.App.urlVars().eventtypeId ?? id), payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderEventtypeList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/recruitment-event-type', payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderEventtypeList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/recruitment/event-type/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().eventtypeId) || (entity === 'event-type' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/recruitment-event-type/' + (window.App.urlVars().eventtypeId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"eventtype-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-8"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-4"}>
              <Field name="color" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label
                    htmlFor="color"
                    className={classNames({'p-error': isFormFieldValid(meta)})}
                  >{props.t('fieldColor')}</label>

                  <div className="p-d-flex p-ai-center" style={{ gap: '0.5rem' }}>
                    <ColorPicker
                      inputId="color"
                      value={(formData.color || '').replace('#', '')}
                      onChange={(e) => {
                        const color = '#' + e.value;

                        setFormData({
                          ...formData,
                          color: color
                        });

                        setNewFormData({
                          ...newFormData,
                          color: color
                        });
                      }}
                    />

                    <InputText
                      value={formData.color || ''}
                      placeholder={t('colorExamplePlaceholder')}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          color: e.target.value
                        });

                        setNewFormData({
                          ...newFormData,
                          color: e.target.value
                        });
                      }}
                    />

                    <span
                      style={{
                        width: '24px',
                        height: '24px',
                        minWidth: '24px',
                        borderRadius: '4px',
                        backgroundColor: formData.color || 'transparent',
                        border: '1px solid #ccc',
                        display: 'inline-block'
                      }}
                    />
                  </div>

                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


            <div className={"p-col-12 p-lg-12"}>
              <div className={"p-col-12 p-lg-3"}>
                <Field name="is_employee" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label
                      htmlFor="is_employee"
                      className={classNames({'p-error': isFormFieldValid(meta)})}
                    >{props.t('fieldIsEmployee')}</label>
                    <span className="p-d-block">
                      <Checkbox
                        inputId="is_employee"
                        className="p-mt-1"
                        checked={!!formData.is_employee}
                        onChange={(e) => setFormData({...formData, is_employee: e.checked})}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            </div>


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'event-type' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(EventtypeFormComponent);
